// extracted by mini-css-extract-plugin
export var label = "_dw-2";
export var slideContainer = "_dw-0";
export var slider = "_dw-1";